
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModulosDocumentumUtilService {

    constructor() { }

    procesarParametrosGenerico<T>(cadena: string, keys: (keyof T)[], separador: string = '-'): T {
        const valores = this.separarParametros(cadena, separador);
        const resultado = {} as T;

        keys.forEach((key, i) => {
            resultado[key] = (valores[i] ?? null) as unknown as T[typeof key];
        });
        return resultado;
    }

    generarCadenaParametros(...valores: (string | number | null | undefined)[]): string {
        return valores.filter(v => v != null && v != undefined).join('-');
    }

    separarParametros(identific: string, separador: string = '-'): string[] {
        return identific?.trim() ? identific.trim().split(separador) : [];
    }
}